import { Form, Input, Modal } from "antd";
import { useTranslation } from "react-i18next";

interface NewCredentialModalProps {
  onCancel: () => void;
  onSubmit: (name: string) => void;
  open: boolean;
}

interface FormValues {
  name: string;
}

export const NewCredentialModal = ({
  open,
  onCancel,
  onSubmit,
}: NewCredentialModalProps) => {
  const { t } = useTranslation("sandbox");
  const [form] = Form.useForm<FormValues>();

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      onSubmit(values.name);
    } catch {}
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      open={open}
      onCancel={handleCancel}
      title={t("components.newCredentialModal.title")}
      onOk={handleOk}
      okText={t("components.newCredentialModal.createCredential")}
      width={520}
      afterClose={form.resetFields}
    >
      <Form form={form} layout="vertical" requiredMark={false}>
        <Form.Item
          name="name"
          label={t("components.newCredentialModal.credentialName")}
          rules={[
            {
              required: true,
              message: t("validation.required", {
                field: t("components.newCredentialModal.credentialName"),
              }),
            },
          ]}
        >
          <Input
            placeholder={t("components.newCredentialModal.labelPlaceholder")}
            autoFocus
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};
